import { createSlice } from "@reduxjs/toolkit"
let data = []


if (localStorage.getItem("sirenSchedule") !== null && localStorage.getItem("sirenSchedule") !== undefined && localStorage.getItem("sirenSchedule") !== "") {

    data = [JSON.parse(localStorage.getItem("sirenSchedule"))]

}



const Insider = createSlice({
    
    name: "todos",
    initialState: data,
    reducers: {
        schooldetails: (state, action) => {
            return action.payload.data || [];

            // localStorage.setItem("sirenSchedule",JSON.stringify([]))

        }

    },

})

export const { schooldetails } = Insider.actions;
export default Insider.reducer;